import "@mdi/font/css/materialdesignicons.min.css";
import "./style.scss";
import type { AppConfig } from './interfaces';
import { VisualizerEngine } from './VisualizerEngine';

const config: AppConfig = {
  red: 1.0,
  green: 0.5,
  blue: 1.0,
  cameraPosX: 0,
  cameraPosY: -2,
  cameraPosZ: 14,
  cameraLookAtX: 0,
  cameraLookAtY: 0,
  cameraLookAtZ: 0,
  bloomStrength: 0.3,
  bloomRadius: 0.5,
  bloomThreshold: 0.5,
  icosahedronRadius: 4,
  icosahedronDetail: 30,
  fogColor: "black",
  fogNearMin: 5,
  fogNearMax: 1,
  fogFarMin: 30,
  fogFarMax: 15,
  fftSize: 32,
  track: "/Third.mp3",
  trackTitle: "First",
  trackAlbum: "I",
  trackArtist: "Valhal",
  enableColorCursor: false,
};

const engine = new VisualizerEngine(config);
engine.start();